import { Box } from "@chakra-ui/react";

function ImageWindow() {
  return (
    <Box width="full" height="23%" borderRadius="12px">
      <a
        href="https://i360.city/phuket/#node221,-47.0483,-8.65353,100,4,0"
        target="_blank"
        rel="noopener noreferrer"
      >
        <iframe
          src="https://i360.city/phuket/#node221,-47.0483,-8.65353,100,4,0"
          width="100%"
          height="100%"
          style={{ border: 0, borderRadius: "12px" }}
        >
          Click to See the 360 View in Fullscreen
        </iframe>
      </a>
    </Box>
  );
}

export default ImageWindow;
